import React, { useEffect, useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  FaFileContract,
  FaMoneyBillWave,
  FaCalendarDay,
  FaPercentage,
  FaCreditCard,
  FaTag,
  FaHashtag,
  FaDollarSign,
  FaBalanceScale,
} from "react-icons/fa";
import axios from "axios";
import { FaEye } from "react-icons/fa";
import FinancialPopup from "./FinancialPopup";

const FinancialTab = ({ onFinancialChange, data, accountNoEdit }) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  console.log("🚀 ~ FinancialTab ~ accountNoEdit:", accountNoEdit);
  // All form fields in one object
  const [form, setForm] = useState({
    terms: "",
    currency: "",
    creditMethod: "",
    creditLimit: "",
    dueDays: "",
    discPercent: "",
    // pdc: "",
    vatType: "VATApplied",
    trn: "",
    crn: "",
    marginPercent: "",
    priceSlab: "",
    availableLimit: "",
    openBalance: "",
    openBalanceFC: "",
    openBalanceFCCode: "",
  });

  const [currencyList, setCurrencyList] = useState([]);
  const [oBPopup, setOBPopup] = useState(false);
  const [financialData, setFinancialData] = useState(null);
  const [isOBViewDisabled, setIsOBViewDisabled] = useState(true);
  const [saudiPhase, setSaudiPhase] = useState(false);

  useEffect(() => {
    if (accountNoEdit?.length > 0) {
      fetchDetailsData();
      setIsOBViewDisabled(false);
    }
  }, [accountNoEdit]);

  const fetchDetailsData = async () => {
    const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    const apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTINFO/-/-/-/${accountNoEdit}`;
    try {
      const { data } = await axios.get(apiURL);
      // setDetailsData(data[0]);
      // // Pre-fill primary tel if available
      // if (data[0]?.phone) {
      //   updateField("primaryTel", data[0].phone);
      // }

      if (data && data.length > 0) {
        const fetched = data[0];
        setFinancialData(fetched);

        console.log("fetched in financial:", fetched);
        setForm((prev) => ({
          ...prev,
          discPercent: fetched.discount || "",
          marginPercent: fetched.Margin || "",
          trn: fetched.UserTrn || "",
          priceSlab: fetched.PRICEGRP || "",
          terms: fetched.terms || "",
          openBalance: fetched.openbal || "",
          openBalanceFC: fetched.curopenbal || "",
          dueDays: fetched.duedays || "",
          creditLimit: fetched.climit || "",
          creditMethod: fetched.CREDITMETHOD || "",
          crn: fetched.TRN,
        }));
      }
    } catch (err) {
      console.error("Error fetching details data", err);
    }
  };

  // Fetch currency list
  useEffect(() => {
    const fetchCurrencyList = async () => {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      // const apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${company_code_from_local_storage}/CURRENCY/-/-`;
      const apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${company_code_from_local_storage}/CURRENCY/-/-`;

      try {
        const response = await axios.get(apiURL);
        setCurrencyList(response.data || []);
      } catch (err) {
        console.error("Error fetching currency list", err);
      }
    };

    fetchCurrencyList();

    const currentUserFromLocal = JSON.parse(
      localStorage.getItem("currentUser") || [],
    );
    const vatmodeFromLocal = currentUserFromLocal[0].VATMODE;

    // if (vatmodeFromLocal === "UAE") {
    if (
      vatmodeFromLocal === "SAUDIPHASE1" ||
      vatmodeFromLocal === "SAUDIPHASE2"
    ) {
      setSaudiPhase(true);
    }

    console.log("MODE:", vatmodeFromLocal);
    console.log("saudiPhase:", saudiPhase);
  }, []);

  useEffect(() => {
    if (onFinancialChange) {
      onFinancialChange(form);
    }
  }, [form, onFinancialChange]);

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="grid grid-cols-2 gap-6 bg-white p-4 rounded-lg shadow-md">
      {/* LEFT SIDE */}
      <div className="space-y-3">
        <div>
          <h2 className="text-lg font-semibold text-gray-700 ">
            Financial Information
          </h2>
        </div>
        <div className="flex gap-2">
          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaMoneyBillWave className="mr-2 text-gray-600" /> Currency
            </label>
            <select
              value={form.currency}
              onChange={(e) => updateField("currency", e.target.value)}
              className="w-full px-1 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            >
              {/* <option value="">-- Select Currency --</option> */}
              {currencyList.map((c, index) => (
                <option key={index} value={c.curno}>
                  {c.curno} - {c.cur}
                </option>
              ))}
            </select>
          </div>

          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaPercentage className="mr-2 text-gray-600" /> Disc%
            </label>
            <input
              type="number"
              placeholder="Enter Disc% Here..."
              value={form.discPercent}
              onChange={(e) => updateField("discPercent", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>

          {/* <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaCreditCard className="mr-2 text-gray-600" /> PDC
            </label>
            <input
              placeholder="Enter PDC Here..."
              value={form.pdc}
              onChange={(e) => updateField("pdc", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div> */}
        </div>

        <div className="flex gap-2">
          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaTag className="mr-2 text-gray-600" /> Credit Method
            </label>
            <select
              value={form.creditMethod}
              onChange={(e) => updateField("creditMethod", e.target.value)}
              className="w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            >
              <option value="">-- Select Credit Method --</option>
              <option value="creditBlock">Credit Block</option>
              <option value="blocked">Blocked</option>
              <option value="open">Open</option>
            </select>
          </div>

          <div className="w-1/2 ">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaCalendarDay className="mr-2 text-gray-600" /> Due Days
            </label>
            <input
              type="number"
              placeholder="Enter Due Days Here..."
              value={form.dueDays}
              onChange={(e) => updateField("dueDays", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>
        </div>

        <div className="flex gap-2 ">
          <div className="w-1/2 mt-4 ">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaMoneyBillWave className="mr-2 text-gray-600" /> Credit Limit
            </label>
            <input
              type="number"
              placeholder="Enter Credit Limit Here..."
              value={form.creditLimit}
              onChange={(e) => updateField("creditLimit", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>

          <div className="w-1/2 mt-4 ">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaFileContract className="mr-2 text-gray-600" /> Terms
            </label>
            <input
              placeholder="Enter Terms Here..."
              value={form.terms}
              onChange={(e) => updateField("terms", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="grid grid-cols-1 gap-4">
        <div className="flex gap-2 mt-9">
          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaTag className="mr-2 text-gray-600" /> VAT Type
            </label>
            <select
              value={form.vatType}
              onChange={(e) => updateField("vatType", e.target.value)}
              className="w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            >
              <option value="VATApplied">VAT Applied</option>
              <option value="VATExempted">VAT Exempted</option>
              <option value="ZeroVat">0% VAT</option>
            </select>
          </div>

          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaHashtag className="mr-2 text-gray-600" />{" "}
              {saudiPhase ? <p>VAT Reg No</p> : "CRN"}
            </label>
            <input
              placeholder={`Enter ${saudiPhase ? "VAT Reg No " : "CRN "
                }Here...`}
              value={form.trn}
              onChange={(e) => updateField("trn", e.target.value)}
              className={`placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border  border-gray-200
                `}
            />
          </div>

          {saudiPhase ? (
            <div className="w-1/2">
              <label className="block text-sm font-medium mb-1 flex items-center">
                <FaHashtag className="mr-2 text-gray-600" /> CRN
                <span className="text-red-500 ml-1 ">*</span>
              </label>
              <input
                placeholder={`Enter CRN Here...`}
                value={form.crn}
                onChange={(e) => updateField("crn", e.target.value)}
                className={`placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border  
                ${form.crn?.length < 10
                    ? "border-red-500 outline-red-500"
                    : "border-gray-200"
                  }`}
              />
            </div>
          ) : (
            <div className="w-1/2">
              <label className="block text-sm font-medium mb-1 flex items-center">
                <FaHashtag className="mr-2 text-gray-600" /> TRN
              </label>
              <input
                placeholder={`Enter TRN Here...`}
                value={form.crn}
                onChange={(e) => updateField("crn", e.target.value)}
                className={`placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border  
                border-gray-200`}
              />
            </div>
          )}
        </div>

        <div className="flex gap-2">
          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaDollarSign className="mr-2 text-gray-600" /> Price Slab
            </label>
            <input
              placeholder="Enter Price Slab Here..."
              value={form.priceSlab}
              onChange={(e) => updateField("priceSlab", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>

          {/* <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaMoneyBillWave className="mr-2 text-gray-600" /> Avail. Limit
            </label>
            <input
              placeholder="Enter Available Limit Here..."
              value={form.availableLimit}
              onChange={(e) => updateField("availableLimit", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div> */}
          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaPercentage className="mr-2 text-gray-600" /> Margin%
            </label>
            <input
              type="number"
              placeholder="Enter Margin% Here..."
              value={form.marginPercent}
              onChange={(e) => updateField("marginPercent", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>
        </div>

        <div className="flex gap-2 ">
          <div className="w-1/2 mt-1">
            <div className="flex justify-between items-center ">
              <label className="block text-sm font-medium mb-1 flex items-center">
                <FaBalanceScale className="mr-2 text-gray-600" /> Open Balance{" "}
                <span className="text-xs ml-2">(Home Currency)</span>
              </label>
              <Tooltip
                title={
                  isOBViewDisabled
                    ? "This will be enabled only in edit mode"
                    : "View Opening Balance"
                }
                arrow
                placement="top"
              >
                <button
                  disabled={isOBViewDisabled}
                  onClick={() => setOBPopup(true)}
                  className={`py-1 px-2 rounded  mb-2 shadow-sm border border-gray-200 ${isOBViewDisabled
                      ? "bg-gray-200 cursor-not-allowed"
                      : "bg-gray-300 hover:bg-gray-400"
                    } `}
                >
                  {" "}
                  <FaEye
                    className={`${isOBViewDisabled
                        ? "text-gray-500 cursor-not-allowed"
                        : "text-gray-700 hover:text-gray-900  "
                      } `}
                  />
                </button>
              </Tooltip>
            </div>
            <input
              disabled={true}
              type="number"
              placeholder="Open Balance"
              value={form.openBalance}
              onChange={(e) => updateField("openBalance", e.target.value)}
              className="placeholder-gray-400 cursor-not-allowed w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>
          <div className="w-1/2 mt-2">
            <label className="block text-sm font-medium mb-2 flex items-center">
              <FaBalanceScale className="mr-2 text-gray-600 " /> Open Balance{" "}
              <span className="text-xs ml-2">(Foreign Currency)</span>
            </label>
            <div className="flex ">
              {/* <select
                value={form.openBalanceFCCode}
                onChange={(e) =>
                  updateField("openBalanceFCCode", e.target.value)
                }
                className="w-1/4 px-1 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              >
                <option className="text-xs" value="">
                  -curr-
                </option>
                {currencyList.map((c, index) => (
                  <option key={index} value={c.curno}>
                    {c.curno} - {c.cur}
                  </option>
                ))}
              </select> */}
              <input
                value={currencyList?.[0]?.curno || form.currency}
                readOnly
                className="cursor-not-allowed placeholder-gray-400 w-1/4 px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              />
              <input
                disabled={true}
                type="number"
                placeholder="FC Open Balance"
                value={form.openBalanceFC}
                onChange={(e) => updateField("openBalanceFC", e.target.value)}
                className="placeholder-gray-400 cursor-not-allowed w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              />
            </div>
          </div>
        </div>
      </div>
      {oBPopup && <FinancialPopup setOBPopup={setOBPopup} data={data} />}
    </div>
  );
};

export default FinancialTab;
